import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import MuiRadioGroup from '@mui/material/RadioGroup';
import Radio from './Radio.js';

const _Radio = styled(Radio) `
  ${({ theme }) => `
    margin: ${theme.spacing(1, 0)};
  `}
`;
const RadioGroup = (_a) => {
    var { options, disabled, 'data-testid': testId } = _a, rest = __rest(_a, ["options", "disabled", 'data-testid']);
    return (jsx(MuiRadioGroup, Object.assign({ "data-testid": testId }, rest, { children: options.map((_a, index) => {
            var { label, 'data-testid': optionTestId } = _a, item = __rest(_a, ["label", 'data-testid']);
            return (jsx(_Radio, Object.assign({ disabled: disabled || item.disabled }, item, { "data-testid": optionTestId }, { children: label }), `${index}-${item.value}`));
        }) })));
};

export { RadioGroup as default };
//# sourceMappingURL=RadioGroup.js.map
